module.exports = {
    title: "生动化陈列_惠合科技数字营销方案_提升动销、数据监控",
    description: "依托“e店佳”平台，惠合“陈列自检”方案打破了传统业代按期执行、人工审核的陈列检查方式，驱动门店主主动完成生动化陈列，并拍摄上传由平台AI自动审核，实现奖励实时发放。",
    keywords: "生动化陈列,AI图像识别,AI货架识别,陈列自检,营销奖励发放"
}